document.addEventListener('DOMContentLoaded', () => {
  const mainEl = document.querySelector('.mc-gallery-swiper');
  const thumbsEl = document.querySelector('.mc-gallery-thumbs');
  
  if (!mainEl || !thumbsEl || typeof Swiper === 'undefined') return;

  let thumbsSwiper = null;
  /* ===== サムネイル Swiper初期化　※先に作っておくこと ===== */
  function initThumbsSwiper() {
    if (window.innerWidth < 750 && !thumbsSwiper) {
      thumbsSwiper = new Swiper(thumbsEl, {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 8,
        watchSlidesProgress: true,
        speed: 300,
        
        mousewheel: {
          forceToAxis: true, // 横方向だけに効かせる（重要） 
          sensitivity: 3, 
          releaseOnEdges: true, // 端でページスクロールへ逃がす（好みで） 
        }, 
        
        /* スワイプ挙動の安定化 */ 
        watchOverflow: true, 
        resistanceRatio: 0.85, 
        threshold: 8, 
        preventClicks: true, 
        preventClicksPropagation: true,

        /* ボタン */
        navigation: {
          nextEl: '.mc-thumb-button--next', 
          prevEl: '.mc-thumb-button--prev', 
        },

      });
    }

    if (window.innerWidth >= 750 && thumbsSwiper) {
      thumbsSwiper.destroy(true, true);
      thumbsSwiper = null;
    }
  }

  initThumbsSwiper();

  if (thumbsSwiper) {
    thumbsSwiper.update();
  }

  window.addEventListener('resize', () => {
    initThumbsSwiper();
  });

  /* ===== サムネイル active 切替 ===== */
  const thumbSlides = Array.from(
    document.querySelectorAll('.mc-thumb-slide')
  );

  function updateThumbActive(index) {
    thumbSlides.forEach((slide) => {
      slide.classList.remove('is-active');
    });

    // indexが一致するtargetを探して、
    const target = thumbSlides.find(
      (slide) => Number(slide.dataset.thumbIndex) === index
    );
    
    // activeにする
    if (target) {
      target.classList.add('is-active');
    }

    // ★ モバイル時のみサムネイルを追従スクロール
    if (thumbsSwiper && window.innerWidth < 750) {
      thumbsSwiper.slideTo(index, 600);
    }
  }

  
/* ===============メインSwiper初期化=============== */
  const mainSwiper = new Swiper(mainEl, {
    /* 基本 */
    slidesPerView: 1,
    loop: true,
    speed: 800,
    centeredSlides: true,
    spaceBetween: 5, // スライド間の距離

    /* ★ 明示的にスワイプを有効化 */
    allowTouchMove: true,
    simulateTouch: true,

    
    //注意！MacBook のトラックパッドで 2 本指で左右に動かす → wheel（横スクロール）→ Swiper はデフォルトでは wheel でスライドしません
    // 「トラックパッド2本指横スワイプ」を拾う
    mousewheel: {
      forceToAxis: true,       // 横方向だけに効かせる（重要）
      sensitivity: 1,
      releaseOnEdges: true,    // 端でページスクロールへ逃がす（好みで）
    },

    /* スワイプ挙動の安定化 */
    watchOverflow: true,
    resistanceRatio: 0.85,
    threshold: 8,
    preventClicks: true,
    preventClicksPropagation: true,

    /* 矢印ナビゲーション */
    navigation: {
      nextEl: '.mc-swiper-button-next',
      prevEl: '.mc-swiper-button-prev',
    },

    /* Dawn の画像ロード事情に対処 */
    preloadImages: false,
    observer: true,
    observeParents: true,

    /* アクセシビリティ */
    a11y: {
      enabled: true,
    },
    /*メイン Swiper が切り替わった瞬間に呼ばれるイベント*/ 
    on: { 
      slideChange(swiper) { 
        const index = swiper.realIndex; 
        updateThumbActive(index); 
      }, 
    },

    
  });

  updateThumbActive(mainSwiper.realIndex);

  
  

  

  /* =============== サムネイルクリック → メイン切替 =============== */
  

  thumbSlides.forEach((slide) => {
    slide.addEventListener('click', () => {
      const index = Number(slide.dataset.thumbIndex);
      if (Number.isNaN(index)) return;

      /* loop:true 対応 */
      mainSwiper.slideToLoop(index, 600);
      updateThumbActive(index); 
   });
  });
});